import React from 'react';
import TextField from '@mui/material/TextField';
import { Box } from '@mui/system';
import Grid from '@mui/material/Grid';
import {Typography, Button} from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Colors from "../../components/ui/Colors";
import NumberFormat from "react-number-format";
import MenuItem from '@mui/material/MenuItem';
import swal from "sweetalert";
import { PuffLoader } from "react-spinners";
import { css } from "@emotion/react";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import moment from 'moment';
import 'moment/locale/es';
import {updateDeliveryOrder, getAllTransporters} from "../../utilityFunctions/WarehouseUtil.js";
import {transportArray, destinationNutrion} from "../../Api.js"
import { useHistory} from "react-router-dom";

const cssLoader = css`
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

const updateOrderRequest = {
    id: null,
    date: null,
    transporter: null,
    driverName: null,
    driverId: null,
    carPlate: null,
    transportCost: null,
    destination: null,
    destinationRegion: null,
    destinationType: null,
    comment: null,
}

const destinationTypeArray = [{tipo: "Nacional"}, {tipo: "Urbano"},]

export default function UpdateDeliveryOrder(props) {

    const {loginUser} = props;

    const history = useHistory();

    const [loading, setLoading] = React.useState(false);
    const [sortedDestinations, setSortedDestinations] = React.useState([]);
    const [transporters, setTransporters] = React.useState("");

    const setPropertiesToNull = (obj) => {
        for (const prop in obj) {
          if (obj.hasOwnProperty(prop)) {
            obj[prop] = null;
          }
        }
      }

    React.useEffect(()=> {
        setPropertiesToNull(updateOrderRequest);
        initialValues();
    }, []);

    const initialValues = async () => {

        const transporters = await getAllTransporters(loginUser.jwtToken);

        if(!transporters) {
            swal({
                title: "Ocurrio un error",
                text: "Inténtalo de nuevo.",
                icon: "error",
                buttons: "OK"
            }).then(() => {
                history.push("/handle_profile");
            });
            return;
        };

        setTransporters(transporters);

        const sortedArray = [...destinationNutrion].sort((a, b) => {
            const nameA = a.Destino.toUpperCase();
            const nameB = b.Destino.toUpperCase();

            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        });
        setSortedDestinations(sortedArray);

        updateOrderRequest.id = props.location.state.order.map((el) => {
            return el.id;
        });
    };

    const [selectedDate, setSelectedDate] = React.useState("");
    const [transporter, setTransporter] = React.useState("");
    const [driverName, setDriverName] = React.useState("");
    const [driverId, setDriverId] = React.useState("");
    const [carPlate, setCarPlate] = React.useState("");
    const [transportCost, setTransportCost] = React.useState("");
    const [destination, setDestination] = React.useState("");
    const [destinationType, setDestinationType] = React.useState("");
    const [comment, setComment] = React.useState("");;


    const handleDateChange = (date) => {
        setSelectedDate(moment(date).format('YYYYMMDD'));
        updateOrderRequest.date=moment(date).format('YYYYMMDD');
    };

    const transporterChange = (e) => {
        setTransporter(e.target.value);
        updateOrderRequest.transporter = e.target.value;
    };

    const driverNameChange = (e) => {
        setDriverName(e.target.value);
        updateOrderRequest.driverName = e.target.value;
    };

    const driverIdChange = (e) => {
        setDriverId(e.target.value);
        updateOrderRequest.driverId = e.target.value;
    };

    const carPlateChange = (e) => {
        setCarPlate(e.target.value);
        updateOrderRequest.carPlate = e.target.value;
    };

    const transportCostChange = (e) => {
        // console.log(e.floatValue);
        setTransportCost(e.floatValue);
        updateOrderRequest.transportCost = e.floatValue;
    };

    const destinationChange = (e) => {
        setDestination(e.target.value);
        setDestinationType(e.target.value.TIPO);
        updateOrderRequest.destination = e.target.value.Destino;
        updateOrderRequest.destinationRegion = e.target.value.REGIONAL;
        updateOrderRequest.destinationType = e.target.value.TIPO;
    };

    const destinationTypeChange = (e) => {
        setDestinationType(e.target.value);
        updateOrderRequest.destinationType = e.target.value;
    };

    const commentChange = (e) => {
        setComment(e.target.value);
        updateOrderRequest.comment = e.target.value;
    };

    const updateDelOrder = async() => {

        setLoading(true);
        const receivedOrder = await updateDeliveryOrder(updateOrderRequest, loginUser.jwtToken);
        setLoading(false);

        if(!receivedOrder){
            swal({
                title: "Ocurrio un error",
                text: "Inténtalo de nuevo.",
                icon: "error",
                buttons: "OK"
            });
            return;
        }

        swal({
            title: "Actualización exitosa",
            icon: "success",
            buttons: "OK"
        });
    };

    // ── Render ───────────────────────────────────────────────────────────────

    return (
        <Box sx={{display: "flex", justifyContent: "center", width: "100%", height: "100%"}}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    width: "95%",
                    height: "90%",
                    textAlign: "center",
                    marginTop: {xs: "1.3rem", sm: "1rem"},
                }}
            >
            {loading ? <PuffLoader size={100} color={Colors.secondary} css={cssLoader} /> :
                <Grid container direction="row" spacing={3}>

                    {/* ── Sección: Información de Transporte ── */}
                    <Grid item xs={12}>
                        <Card variant="outlined" sx={{ borderColor: Colors.primary + "55", borderRadius: 2 }}>
                            <CardContent>
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: Colors.primary, mb: 2, textAlign: "left" }}>
                                    Información de Transporte
                                </Typography>
                                <Grid container spacing={2}>
                                    {transporters &&
                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextField
                                            sx={{textAlign: "start"}}
                                            variant="standard"
                                            fullWidth={true}
                                            id="transporter"
                                            name="transporter"
                                            select
                                            label={<Typography variant="body2">Transportadora</Typography>}
                                            value={transporter}
                                            onChange={(e)=>transporterChange(e)}
                                            autoComplete="off"
                                        >
                                            {transporters.map((el) => (
                                                <MenuItem key={el.name} value={el.name}>
                                                    {el.name}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    }
                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextField
                                            variant="standard"
                                            fullWidth={true}
                                            id="driverName"
                                            name="driverName"
                                            label={<Typography variant="body2">Nombre Conductor</Typography>}
                                            value={driverName}
                                            onChange={(e)=> driverNameChange(e)}
                                            autoComplete="off"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextField
                                            variant="standard"
                                            fullWidth={true}
                                            id="driverId"
                                            name="driverId"
                                            label={<Typography variant="body2">Identificación Conductor</Typography>}
                                            value={driverId}
                                            onChange={(e)=> driverIdChange(e)}
                                            autoComplete="off"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextField
                                            variant="standard"
                                            fullWidth={true}
                                            id="carPlate"
                                            name="carPlate"
                                            label={<Typography variant="body2">Placa Transporte</Typography>}
                                            value={carPlate}
                                            onChange={(e)=> carPlateChange(e)}
                                            autoComplete="off"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <NumberFormat
                                            variant="standard"
                                            style={{width: "100%", height: "90%"}}
                                            name="transportCost"
                                            customInput={TextField}
                                            prefix={'$ '}
                                            type="transportCost"
                                            label={<Typography variant="body2">Costo Transporte</Typography>}
                                            thousandSeparator={'.'}
                                            decimalSeparator={','}
                                            autoComplete="off"
                                            value={transportCost}
                                            onValueChange={(values) => {
                                                transportCostChange(values);
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>

                    {/* ── Sección: Información de la Orden ── */}
                    <Grid item xs={12}>
                        <Card variant="outlined" sx={{ borderColor: Colors.secondary + "55", borderRadius: 2 }}>
                            <CardContent>
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: Colors.primary, mb: 2, textAlign: "left" }}>
                                    Información de la Orden
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6} md={4} sx={{width: "100%"}}>
                                        <LocalizationProvider dateAdapter={AdapterMoment}>
                                            <DesktopDatePicker
                                                timezone="America/Bogota"
                                                locale="es"
                                                label={<Typography variant="body2">Fecha de despacho</Typography>}
                                                inputFormat="DD/MM/YYYY"
                                                value={selectedDate}
                                                onChange={handleDateChange}
                                                renderInput={(params) =>
                                                    <TextField {...params}
                                                        variant="standard"
                                                        fullWidth
                                                    />}
                                            />
                                        </LocalizationProvider>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextField
                                            sx={{textAlign: "start"}}
                                            variant="standard"
                                            fullWidth={true}
                                            id="destination"
                                            name="destination"
                                            select
                                            label={<Typography variant="body2">Destino</Typography>}
                                            value={destination}
                                            onChange={(e)=>destinationChange(e)}
                                            autoComplete="off"
                                        >
                                            {sortedDestinations.map((el) => (
                                                <MenuItem key={el.Destino} value={el}>
                                                    {el.Destino}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextField
                                            sx={{textAlign: "start"}}
                                            variant="standard"
                                            fullWidth={true}
                                            id="destinationType"
                                            name="destinationType"
                                            select
                                            label={<Typography variant="body2">Tipo Destino</Typography>}
                                            value={destinationType}
                                            onChange={(e)=>destinationTypeChange(e)}
                                            autoComplete="off"
                                        >
                                                {destinationTypeArray.map((el) => (
                                                <MenuItem key={el.tipo} value={el.tipo}>
                                                    {el.tipo}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth={true}
                                            multiline
                                            rows={2}
                                            id="comment"
                                            name="comment"
                                            label={<Typography variant="body2">Comentario</Typography>}
                                            value={comment}
                                            onChange={(e)=> commentChange(e)}
                                            autoComplete="off"
                                        />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>

                    {/* ── Botón Actualizar Orden ── */}
                    {selectedDate && transporter && driverName && driverId && carPlate && transportCost && destination && destinationType && comment &&
                    <Grid item xs={12}>
                        <Button onClick={updateDelOrder} variant="contained" sx={{backgroundColor: Colors.primary, marginTop: "0.5rem"}}>
                            Cargar
                        </Button>
                    </Grid>
                    }

                </Grid>
            }
            </Box>
        </Box>
    )
}
